import { useState } from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';

import classNames from 'classnames';

import './HomeCheckerImage.scss';

const HomeCheckerImage = ({ photoUrl = '', defaultNode = null }) => {
  const [imageLoadError, setImageLoadError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleLoad = () => {
    setImageLoaded(true);
  };

  const handleError = () => {
    setImageLoadError(true);
  };

  if (imageLoadError || !photoUrl) {
    return defaultNode;
  }

  const classes = classNames({
    'home-checker-image-variant': true,
    'home-checker-image-variant-loading': !imageLoaded
  });

  return (
    <NoSSR>
      <img
        onLoad={handleLoad}
        onError={handleError}
        className={classes}
        src={photoUrl}
        alt="homechecker"
      />
    </NoSSR>
  );
};

HomeCheckerImage.propTypes = {
  photoUrl: PropTypes.string,
  defaultNode: PropTypes.node
};

export default HomeCheckerImage;
